import { useMemo } from "react"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { getOrderPerson } from "../../../../../utils/getOrderPerson"
import { FormikAutoComplete } from "../../../../forms/Formik"
import { CreateOrderDialogMode, CreateOrderFlowType } from "../../../createOrderTypes"
import { useCreateOrderFormOptional } from "../../../mainForm/CreateOrderFormContext"

export const WORKGROUP_FIELD = "workgroupId"
export const NO_WORKGROUP = null

type WorkgroupFormValues = Readonly<{ [WORKGROUP_FIELD]: string | null }>

export function WorkgroupSelect() {
    const form = useCreateOrderFormOptional()
    const workgroups = form?.workgroups ?? []

    const options = useMemo(() => workgroups.map((workgroup) => String(workgroup.id)), [workgroups])
    const namesById = useMemo(
        () => new Map(workgroups.map((workgroup) => [String(workgroup.id), workgroup.name])),
        [workgroups],
    )

    if (!form || form.flowConfig?.flow === CreateOrderFlowType.OUTLOOK || workgroups.length === 0) return null

    const { user, orderPeople, orderContext } = form
    const creatorId = orderPeople?.customerId ?? getOrderPerson(orderPeople?.organizers).creator?.id
    const isLockedForMember =
        orderContext.mode === CreateOrderDialogMode.EDIT && creatorId !== undefined && creatorId !== user.userId

    return (
        <LocalizedStrict id="create-order-workgroup-label" attrs={{ label: true }}>
            <FormikAutoComplete<WorkgroupFormValues, string>
                name={WORKGROUP_FIELD}
                label="Workgroup"
                fullWidth
                size="small"
                renderInput={() => <></>}
                options={options}
                getOptionLabel={(id) => namesById.get(id) ?? ""}
                disabled={isLockedForMember}
            />
        </LocalizedStrict>
    )
}
